import { useDeleteFacility } from '../hooks/useDeleteFacility'
import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useTranslation } from 'react-i18next'
import { HiOutlineArchive, HiOutlineTrash } from 'react-icons/hi'

import {
  Box,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@chakra-ui/react'

import { Modal } from '@/components/overlays'
import { Button } from '@/components/ui'

import { ListItemSkeleton } from '../../components/ListItemSkeleton'
import { FacilityErrorView } from './FacilityErrorView'
import { ModalBodyConent } from './ModalBodyConent'

interface DeleteFacilityModalIProps {
  facilityId: string
  isOpen: boolean
  onClose: () => void
}

export const DeleteFacilityModal = ({
  facilityId,
  isOpen,
  onClose,
}: DeleteFacilityModalIProps) => {
  const { t } = useTranslation()
  const isArchivePresentation = useFeatureFlag(
    FeatureFlag.archiveFloorAndFacility
  )
  const { data, error, deleteFacility, hasUnresolvedIncidents, dataLoaded } =
    useDeleteFacility({ id: facilityId, onClose })

  return (
    <Modal
      id='facilitiesPage_removeFacilityModal'
      isCentered
      isOpen={isOpen}
      motionPreset='slideInBottom'
      onClose={onClose}
      size='xl'
    >
      <ModalOverlay />
      <ModalContent bg='#fff' overflow='hidden'>
        <ModalCloseButton color='#000' opacity={0.4} />
        {error ? (
          <FacilityErrorView onClose={onClose} />
        ) : (
          <>
            <ModalBody p='0'>
              {!dataLoaded ? (
                <ListItemSkeleton />
              ) : (
                <ModalBodyConent
                  facilityName={data?.name}
                  hasUnresolvedIncidents={hasUnresolvedIncidents}
                />
              )}
            </ModalBody>
            {dataLoaded && (
              <Box px='4'>
                <ModalFooter px='0'>
                  <Button
                    data-testid='facilitiesPage_removeFacilityModal_cancelButton'
                    mr={3}
                    onClick={onClose}
                    variant='ghost'
                  >
                    {t('common:cancel')}
                  </Button>
                  <Button
                    data-testid='facilitiesPage_removeFacilityModal_removeButton'
                    isDisabled={hasUnresolvedIncidents}
                    leftIcon={
                      isArchivePresentation ? (
                        <HiOutlineArchive size='24px' />
                      ) : (
                        <HiOutlineTrash size='24px' />
                      )
                    }
                    loadingText={
                      isArchivePresentation
                        ? t('facilities:archive_loading')
                        : t('facilities:delete_loading')
                    }
                    onClick={deleteFacility}
                    variant='danger'
                  >
                    {isArchivePresentation
                      ? t('facilities:archive_button')
                      : t('common:delete')}
                  </Button>
                </ModalFooter>
              </Box>
            )}
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
